// extracted by mini-css-extract-plugin
export default {"movie":"MovieItem_movie__FIDz9","movie-img":"MovieItem_movie-img__Ec5sk","movie-title":"MovieItem_movie-title__eQRKo"};